import React from 'react';
import { toast } from 'react-toastify';
import NotifyIcon from '../components/common/NotifyIcon';
import { CheckCircle2, XCircle, Info, AlertTriangle, ChevronRight } from 'lucide-react';

const PRESETS = {
  success: { color: '#22c55e', icon: <CheckCircle2 size={18} />, title: 'Başarılı' },
  error:   { color: '#ef4444', icon: <XCircle size={18} />,      title: 'Hata' },
  info:    { color: '#3b82f6', icon: <Info size={18} />,          title: 'Bilgi' },
  warn:    { color: '#f59e0b', icon: <AlertTriangle size={18} />, title: 'Uyarı' },
};

const show = (type, message, overrides = {}) => {
  const p = PRESETS[type] || PRESETS.info;
  const color = overrides.color || p.color;
  const title = overrides.title || p.title;

  const opts = {
    autoClose: overrides.autoClose || 4000,
    pauseOnHover: false,
    pauseOnFocusLoss: false,
    closeButton: false,
    style: {
      background: '#ffffff',
      borderRadius: '16px',
      border: `1px solid ${color}30`,
      boxShadow: `0 8px 32px rgba(0,0,0,0.10)`,
      padding: '0',
      backdropFilter: 'none',
      overflow: 'hidden',
    },
    progressStyle: { background: `linear-gradient(90deg, ${color}, ${color}80)`, height: '2px' },
  };

  if (overrides.toastId) {
    if (toast.isActive(overrides.toastId)) return;
    opts.toastId = overrides.toastId;
  }

  toast(
    <div className="ft-toast">
      <div className="ft-toast-accent" style={{ background: color }} />
      <div className="ft-toast-icon" style={{ color }}>
        {overrides.icon || p.icon}
      </div>
      <div className="ft-toast-body">
        <div className="ft-toast-title">{title}</div>
        <div className="ft-toast-msg">{message}</div>
      </div>
    </div>,
    opts
  );
};

export const fleetToast = {
  success: (msg, o) => show('success', msg, o),
  error:   (msg, o) => show('error', msg, o),
  info:    (msg, o) => show('info', msg, o),
  warn:    (msg, o) => show('warn', msg, o),
};

/* App.jsx'ten taşındı (Task 11 fix round 2): fleetNotificationRouter.js da bu toast'ı
   çağırmak zorunda ve App.jsx zaten router'ı import ediyor — showFleetToast App.jsx'te
   kalsaydı router'ın onu geri import etmesi bir modül döngüsü oluştururdu (ES modülleri
   bunu tolere eder ama showFleetToast bir `const` olduğu için TDZ çökmesi riski taşır).
   Bağımsız bir modülde durarak hem App.jsx hem router aynı kaynaktan, döngüsüz okur. */
export const showFleetToast = (cfg) => {
    const opts = {
        autoClose: cfg.autoClose || 4000,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        onClick: cfg.navigate ? () => cfg.navigate() : undefined,
        closeButton: false,
        style: {
            background: '#ffffff',
            borderRadius: '14px',
            border: `1px solid #e4e4e7`,
            boxShadow: `0 8px 28px rgba(0,0,0,0.10), 0 1px 3px rgba(0,0,0,0.06)`,
            padding: '0',
            cursor: cfg.navigate ? 'pointer' : 'default',
            overflow: 'hidden',
        },
        progressStyle: { background: `linear-gradient(90deg, ${cfg.color}, ${cfg.color}80)`, height: '2px' },
    };
    if (cfg.toastId) {
        if (toast.isActive(cfg.toastId)) return;
        opts.toastId = cfg.toastId;
    }
    toast(
        <div className="ft-toast">
            <div className="ft-toast-accent" style={{ background: cfg.color }} />
            <div className="ft-toast-icon" style={{ color: cfg.color }}>
                <NotifyIcon name={cfg.icon} />
            </div>
            <div className="ft-toast-body">
                <div className="ft-toast-title">{cfg.title}</div>
                <div className="ft-toast-msg">{cfg.message}</div>
                {cfg.subtitle && <div className="ft-toast-sub" style={{ color: cfg.color }}>{cfg.subtitle}</div>}
            </div>
            {cfg.navigate && <ChevronRight size={16} className="ft-toast-nav" />}
        </div>,
        opts
    );
};
